import React from "react";
import SideBar from "components/SideBar/SideBar";
import SocialTray from "components/SocialTray/SocialTray";
import ThemeToggle from "components/ThemeToggle/ThemeToggle";

interface HomeProps {
  // Define any props if needed, but not specified in the original file
}

const Home: React.FC<HomeProps> = () => {
  return (
    <>
      <SideBar />
      <div className="fixed right-8 top-1/2 transform -translate-y-1/2">
        <ThemeToggle />
        <SocialTray />
      </div>
    </>
  );
};

export default Home;
